/* Stylesheet */

.simple_slider {
  .slider {
    padding: 0px 4px 0px 4px;
    --bar-background: #2f4569;
    --bar-background-active: var(--ion-color-primary);
  }

  .disabled {
    opacity: 0.175;
  }
}
